import Form from '../../../../form_builder_2/form';

export default class PartialRegisterView {
    constructor(parent) {
        this.parent = parent;
        this.util = this.parent.parent;
        this.el = parent.el.querySelector('.partial-register-view');
        this.form = new Form(this.parent.el.querySelector('.partial-register-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    onSuccess(result) {
        this.parent.hide();
        this.util.onLogin(); 
    }

    onError(result) {
        this.form.showError();
    }
}
